import { Master } from 'little-state-machine';
import React from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { AppError } from '../../../framework/models/errors';
import { Overwrite, TypeUtils } from '../../../framework/utils/UtilityTypes';
import { pageKeywords, pageNames, pagePaths } from '../../constants/Page';
import { useGetOutsourceMemberReport } from '../../hooks/queries/outsourceMemberReport';
import useToastHook from '../../hooks/ToastHook';
import { OutsourceMemberReportGetResultResult } from '../../models/gen/outsourceMemberReportGetResultResult';
import Wireframe from '../wireframe/Wireframe';

export type OutsourceMemberReportOutletContext = Overwrite<
  OutsourceMemberReportGetResultResult,
  {
    tasks?: Array<Master>;
    attendanceTypes?: Array<Master>;
  }
> & {
  authCode?: string;
  isLoading?: boolean;
  mode?: 'edit' | 'view';
};

/**
 * `/outsource-member-report`
 */
const OutsourceMemberReport: React.FunctionComponent = (props) => {
  console.debug('render Root');
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const authCode = searchParams.get('authCode');

  const { data, error, isError, isLoading, refetch, isFetched } =
    useGetOutsourceMemberReport(authCode);
  React.useState(() => !TypeUtils.isNilString(authCode) && refetch());
  React.useEffect(() => {
    if (isError) {
      toast(error instanceof AppError ? error : '');
    }
  }, [isError]);

  const { toast } = useToastHook();

  const facilitySettings = React.useMemo(
    () =>
      Object.entries(data?.result?.facilitySettings || {}).reduce(
        (prev, [curK, curV]) => ({
          ...prev,
          [curK]: /^\d{4}-\d{2}-\d{2}$/.test(curV as string)
            ? curV
            : JSON.parse(curV),
        }),
        {}
      ),
    [data?.result?.facilitySettings]
  );

  if (
    TypeUtils.isNilString(authCode) &&
    !location.pathname.startsWith(`${pagePaths.ROOT}/error`)
  ) {
    return <Navigate to="error403" />;
  }

  if (!isLoading && isFetched && location.pathname === pagePaths.ROOT) {
    if (TypeUtils.isNil(authCode)) {
      return <Navigate to="error403" />;
    }
    if (TypeUtils.isNonNil(data?.result?.workReport)) {
      return (
        <Navigate
          to={`${pagePaths.WORK_CONTENT}/${
            data?.result?.isApproved
              ? pageKeywords.mode.VIEW
              : pageKeywords.mode.EDIT
          }?authCode=${authCode}`}
        />
      );
    }
    if (TypeUtils.isNonNil(data?.result?.workDocReport)) {
      return (
        <Navigate
          to={`${pagePaths.WORK_REPORT}/${
            data?.result?.isApproved
              ? pageKeywords.mode.VIEW
              : pageKeywords.mode.EDIT
          }?authCode=${authCode}`}
        />
      );
    }
    if (TypeUtils.isNil(data)) {
      return <Navigate to={`error404?authCode=${authCode}`} />;
    }
  }
  // React.useEffect(() => {
  //   if (!isLoading) {
  //     if (!TypeUtils.isNil(data?.result?.workReport)) {
  //       return (
  //         <Navigate
  //           to={`${pagePaths.WORK_CONTENT}/${
  //             data?.result?.workReport.results?.every((result) =>
  //               TypeUtils.isNilString(
  //                 result.assignedWorkerSummary.reportApprovedTime
  //               )
  //             )
  //               ? pageKeywords.mode.EDIT
  //               : pageKeywords.mode.VIEW
  //           }?authCode=${authCode}`}
  //         />
  //       );
  //     } else if (!TypeUtils.isNil(data?.result?.workDocReport)) {
  //       return (
  //         <Navigate
  //           to={`${pagePaths.WORK_REPORT}/${
  //             data?.result?.workDocReport.dailyMatterReport?.reportDocStatus ===
  //             0
  //               ? pageKeywords.mode.EDIT
  //               : pageKeywords.mode.VIEW
  //           }?authCode=${authCode}`}
  //         />
  //       );
  //     } else if (TypeUtils.isNil(data)) {
  //       return <Navigate to={`error404?authCode=${authCode}`} />;
  //     }
  //   }
  // }, [isLoading]);

  return (
    <Wireframe isLoaded={!isLoading} title={pageNames.ROOT}>
      <Outlet
        context={{
          ...data?.result,
          facilitySettings,
          authCode,
          isLoading,
          mode: 'edit',
        }}
      />
    </Wireframe>
  );
};

export default OutsourceMemberReport;
